import { ThemeEnum } from '../../enum/Theme';
import { BaseResponse } from './BaseResponse';
import { Platform, PlatformType } from '../../util/platform';
import { NUMBER_FORMAT_LOCALES } from '../../constant/constants';
import { Column } from '../../enum/Column';
import { Currency } from '../../enum/Currency';

export interface ApplicationConfig {
  timeZone?: string;
  rowDensity?: number;
  theme?: ThemeEnum;
  themesByPlatform?: PlatformType[];
  format?: keyof typeof NUMBER_FORMAT_LOCALES;
  username?: string;
  columnsByPage?: Record<string, Column[]>;
  selectedCurrency?: string | null;
}

export interface ConfigResponse extends BaseResponse {
  Config: ApplicationConfig;
}

export function mergeConfigs(p1: ApplicationConfig, p2: ApplicationConfig): ApplicationConfig {
  return {
    ...p1,
    ...p2,

    themesByPlatform: mergeThemesByPlatform(p1.themesByPlatform, p2.themesByPlatform),
  };
}

export function mergeThemesByPlatform(p1?: PlatformType[], p2?: PlatformType[]): PlatformType[] | undefined {
  if (!p1 && !p2) return undefined;

  const map = new Map<Platform, PlatformType>();

  p1?.forEach((item) => {
    map.set(item.platform, item);
  });

  p2?.forEach((item) => {
    map.set(item.platform, item);
  });

  return Array.from(map.values());
}
